import { getMembers } from '../lib/data.js';
import { mediaUrl } from '../lib/supabase.js';
import { esc } from '../lib/utils.js';

export async function renderObsazeni(view) {
    const members = await getMembers();

    view.innerHTML = `
        <section class="section narrow">
            <h1 class="page-title">Obsazení</h1>
        </section>

        <section class="section">
            <h2 class="section-title">Kdo hraje</h2>
            ${members.length ? `
                <div class="member-grid">
                    ${members.map((m) => memberCard(m)).join('')}
                </div>`
            : '<p class="empty">Profily členů se brzy doplní.</p>'}
        </section>
    `;
}

function memberCard(m) {
    const photo = mediaUrl(m.photo_path);
    const initials = (m.name || '?').trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
    return `
        <article class="member-card ${photo ? '' : 'no-photo'}"
                 ${photo ? `style="background-image:url('${esc(photo)}')"` : ''}>
            ${photo ? '' : `<span class="member-initials">${esc(initials)}</span>`}
            <div class="member-overlay">
                <h3>${esc(m.name)}</h3>
                ${m.instrument ? `<p class="member-role">${esc(m.instrument)}</p>` : ''}
            </div>
        </article>`;
}
